const COOKIE_PREFIX = 'sta_handoff_';
const TOKEN_COOKIE_NAME = `${COOKIE_PREFIX}token`;
const REFRESH_TOKEN_COOKIE_NAME = `${COOKIE_PREFIX}refresh_token`;

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function expireCookie(name: string): void {
  document.cookie = `${name}=; domain=${process.env.HANDOFF_COOKIE_DOMAIN}; path=/; max-age=0; secure; samesite=Lax`;
}

/**
 * Expires handoff cookies unconditionally.
 * Must be called regardless of whether localStorage already has a token,
 * to ensure sensitive auth cookies don't linger.
 */
export function expireHandoffCookies(): void {
  expireCookie(TOKEN_COOKIE_NAME);
  expireCookie(REFRESH_TOKEN_COOKIE_NAME);
}

/**
 * Reads handoff cookies set by scheduling_time_and_attendance_fe during cross-origin redirect,
 * promotes values to localStorage, and expires the cookies.
 * Returns true if a token was found and stored.
 */
export function bootstrapTokenFromHandoffCookie(): boolean {
  const token = getCookie(TOKEN_COOKIE_NAME);

  if (!token) {
    return false;
  }

  try {
    localStorage.setItem('token', token);

    const refreshToken = getCookie(REFRESH_TOKEN_COOKIE_NAME);
    if (refreshToken) {
      localStorage.setItem('refresh_token', refreshToken);
    }

    return true;
  } finally {
    expireHandoffCookies();
  }
}
